import { render, staticRenderFns } from "./PermissionPage.vue?vue&type=template&id=3b64a814&scoped=true"
import script from "./PermissionPage.vue?vue&type=script&lang=js"
export * from "./PermissionPage.vue?vue&type=script&lang=js"
import style0 from "./PermissionPage.vue?vue&type=style&index=0&id=3b64a814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64a814",
  null
  
)

export default component.exports